import React, { useState } from "react";
import { STATUS_PILLS } from "@/lib/posting";
import { FilterButton } from "./FilterButton";

// v19 look: status pills + parsed chips (reflect active filters, removable) +
// collapsible 3-column advanced form. Date range + search live in the page header.
export function FilterBar({ filters, setFilters, counts = {} }) {
  const [adv, setAdv] = useState(false);
  const set = (patch) => setFilters((f) => ({ ...f, ...patch }));

  const DOT = { unapplied: "pp-amb", applied: "pp-gre", partial: "pp-blu", force: "pp-vio", gap: "pp-red" };

  const chips = [];
  if (filters.batch) chips.push({ k: "batch", label: "Today's batch" });
  if (filters.status && filters.status !== "all")
    chips.push({ k: "status", label: `Status: ${STATUS_PILLS.find((p) => p.id === filters.status)?.label || filters.status}` });
  if (filters.payer) chips.push({ k: "payer", label: `Payer: ${filters.payer}` });
  if (filters.q) chips.push({ k: "q", label: `Search: ${filters.q}` });
  if (filters.amtMin) chips.push({ k: "amtMin", label: `Amount ≥ $${filters.amtMin}` });
  if (filters.amtMax) chips.push({ k: "amtMax", label: `Amount ≤ $${filters.amtMax}` });
  if (filters.dateFrom || filters.dateTo)
    chips.push({ k: "date", label: `Date: ${filters.dateFrom || "…"} → ${filters.dateTo || "…"}` });

  const clearChip = (k) => {
    if (k === "date") return set({ dateFrom: "", dateTo: "" });
    if (k === "batch") return set({ batch: false });
    set({ [k]: k === "status" ? "all" : "" });
  };

  return (
    <div className="pp-searchwrap" data-testid="pp-filterbar">
      {/* Filter toggle + status pills + today's batch (above the money cards) */}
      <div className="pp-toolbar" style={{ marginBottom: 12 }}>
        <FilterButton open={adv} onClick={() => setAdv((v) => !v)} count={chips.length} />
        <div className="pp-viewby" data-testid="pp-status-pills">
          {STATUS_PILLS.map((p) => (
            <button key={p.id} className={`pp-v ${filters.status === p.id ? "pp-on" : ""}`}
              onClick={() => set({ status: p.id })} data-testid={`pp-status-${p.id}`}>
              {DOT[p.id] ? <span className={`pp-dot ${DOT[p.id]}`} /> : null}
              {p.label}
              {counts[p.id] != null ? <span className="pp-ct">{counts[p.id]}</span> : null}
            </button>
          ))}
        </div>
        <div className="pp-viewby">
          <button className={`pp-v pp-batch ${filters.batch ? "pp-on" : ""}`}
            onClick={() => set({ batch: !filters.batch })} data-testid="pp-status-batch">
            ✦ Today's batch
            {counts.batch != null ? <span className="pp-ct">{counts.batch}</span> : null}
          </button>
        </div>
      </div>

      {chips.length ? (
        <div className="pp-parsed pp-on" data-testid="pp-parsed" style={{ marginTop: 0, marginBottom: 12 }}>
          <span className="pp-lbl">revQ read that as:</span>
          {chips.map((c) => (
            <span key={c.k} className="pp-chip" data-testid={`pp-chip-${c.k}`}>
              {c.label}
              <button className="pp-rm" onClick={() => clearChip(c.k)} data-testid={`pp-chip-remove-${c.k}`}>✕</button>
            </span>
          ))}
        </div>
      ) : null}

      <div className={`pp-advform ${adv ? "pp-on" : ""}`} data-testid="pp-adv-row">
        <div className="pp-advgrid">
          <div className="pp-advfld">
            <label>Payer</label>
            <input value={filters.payer || ""} onChange={(e) => set({ payer: e.target.value })} placeholder="Search payer…" data-testid="pp-adv-payer" />
          </div>
          <div className="pp-advfld">
            <label>Check amount</label>
            <div className="pp-rangepair">
              <input value={filters.amtMin || ""} onChange={(e) => set({ amtMin: e.target.value })} placeholder="min" data-testid="pp-adv-amtmin" />
              <input value={filters.amtMax || ""} onChange={(e) => set({ amtMax: e.target.value })} placeholder="max" data-testid="pp-adv-amtmax" />
            </div>
          </div>
          <div className="pp-advfld">
            <label>Check date range</label>
            <div className="pp-rangepair">
              <input type="date" value={filters.dateFrom || ""} onChange={(e) => set({ dateFrom: e.target.value })} data-testid="pp-adv-datefrom" />
              <input type="date" value={filters.dateTo || ""} onChange={(e) => set({ dateTo: e.target.value })} data-testid="pp-adv-dateto" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
